import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("billone_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const biz = localStorage.getItem("billone_business");
  if (biz && !config.headers["X-Business-Id"]) config.headers["X-Business-Id"] = biz;
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("billone_token");
      localStorage.removeItem("billone_user");
      window.location.href = "/";
    }
    return Promise.reject(err);
  }
);

export function apiError(err) {
  const d = err?.response?.data?.detail;
  if (d == null) return err?.message || "Something went wrong. Please try again.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  if (d?.msg) return d.msg;
  return String(d);
}
